//
//
//
//
//
//
//

export default {
    computed: {
        class_name() {
            return ['single', 'double'][this.content.length - 1] || ''
        },
    },
    props: {
        content: Array,
    }
}
